import TPL = require("templates");
import {Config} from "../config";

export class LoginController {

  parent;
  logIn; //true if in login mode, false in signUp mode
  signUp = false; //true if signUp form is visible
  currentModal;
  afterLoginCallback;

  constructor(parent, $rootScope, which, afterLoginCallback?) {
    this.parent = parent;
    this.logIn = which == "login";
    this.currentModal = this.parent.currentModal;
    this.afterLoginCallback = afterLoginCallback;

    var dismissAfterLoginCallback = $rootScope.$on("session.login", () => {
      this.currentModal.dismiss();

      if(this.afterLoginCallback != null) {
        this.afterLoginCallback();
        this.afterLoginCallback = null;
      }

      dismissAfterLoginCallback();
    });
  }


  getTermsLink() {
    return Config.wp_termsandconditions;
  }

  getLocationLink() {
    return Config.wp_locations;
  }

  static openLoginModal(modal, parent, rootScope, afterLoginCallback?) {
    return modal.open({
          controller: () => new LoginController(parent, rootScope, "login", afterLoginCallback),
          controllerAs: "vm",
          replace: true,
          size: "md",
          template: TPL.modals.login
        });
  }

  static openSignupModal(modal, parent, rootScope) {
    return modal.open({
          controller: () => new LoginController(parent, rootScope, "signup"),
          controllerAs: "vm",
          replace: true,
          size: "md",
          template: TPL.modals.login
        });
  }

  isOnward (){
    if (Config.isOnward) {
      return true;
    }
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/login.ts
 **/